import { Grid } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./digital.wallet.css";
import { PermissionName } from "@/models/apiModels";
import { checkPermissionsWithoutAlert, checkWalletSource } from "@/util";

const DigitalWalletPage: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isWalletManagementVisible =
        checkPermissionsWithoutAlert(PermissionName.WalletManagment) && checkWalletSource();

    return (
        <Grid className="digital-wallet-menu-block">
            {checkPermissionsWithoutAlert(PermissionName.ListOfWallets) && (
                <Grid className="digital-wallet-menu-item" onClick={() => navigate("/digital-wallet/list")}>
                    <span>{t("digitalWallet.ListOfWallets")}</span>
                </Grid>
            )}
            {isWalletManagementVisible && (
                <Grid className="digital-wallet-menu-item" onClick={() => navigate("/digital-wallet/management")}>
                    <span>{t("digitalWallet.WalletManagement")}</span>
                </Grid>
            )}
            {checkPermissionsWithoutAlert(PermissionName.ListOfTransactions) && (
                <Grid className="digital-wallet-menu-item" onClick={() => navigate("/digital-wallet/transactions")}>
                    <span>{t("breadcrumbs.DigitalWalletTransactions")}</span>
                </Grid>
            )}
        </Grid>
    );
};

export default DigitalWalletPage;
